(function () {
  'use strict';

  var VISIBLE = 3; // cards visible at a time

  document.querySelectorAll('[data-slime-lab]').forEach(function (section) {
    initStateMachine(section);
    initCarousel(section);
    initMuteButtons(section);
  });

  /* ── State machine: idle → video → revealed → idle ── */
  function initStateMachine(section) {
    var enterBtn = section.querySelector('[data-slime-enter]');
    var exitBtn  = section.querySelector('[data-slime-exit]');
    var video    = section.querySelector('[data-slime-intro-video]');

    /* Pick mobile or desktop video source — swaps live when breakpoint crosses */
    if (video && video.dataset.srcDesktop) {
      var mq = window.matchMedia('(max-width: 550px)');

      function applyVideoSrc() {
        var newSrc = mq.matches ? video.dataset.srcMobile : video.dataset.srcDesktop;
        if (video.getAttribute('src') !== newSrc) {
          video.src = newSrc;
          /* Deliberately no video.load() here. Calling it on page load forced
             the whole intro (2.2 MB on mobile, 2.9 MB on desktop) to download
             for every visitor, which overrode the preload="none" on the element
             and was ~40% of the homepage's transfer. The Enter handler below
             already covers the not-yet-loaded case: it sets preload="auto",
             calls load(), and waits for `canplay` before playing. Setting .src
             alone does not fetch while preload="none". */
        }
      }

      applyVideoSrc();                          // set correct src on load
      mq.addEventListener('change', applyVideoSrc); // swap when breakpoint crosses
    }

    if (enterBtn) {
      enterBtn.addEventListener('click', function () {
        if (section.dataset.state !== 'idle') return;
        enterBtn.disabled = true;

        if (!video) { section.dataset.state = 'video'; return; }

        function startVideo() {
          section.dataset.state = 'video';
          video.currentTime = 0;
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        }

        /* If enough data is already buffered, play immediately */
        if (video.readyState >= 3) {
          startVideo();
          return;
        }

        /* Otherwise load and wait for first frame to be ready */
        video.preload = 'auto';
        video.load();
        video.addEventListener('canplay', startVideo, { once: true });
      });
    }

    if (video) {
      video.addEventListener('ended', function () {
        section.dataset.state = 'revealed';
        autoPlayAll(section);
        section.dispatchEvent(new CustomEvent('slime:revealed'));
      });
    }

    if (exitBtn) {
      exitBtn.addEventListener('click', function () {
        section.dataset.state = 'idle';
        if (enterBtn) enterBtn.disabled = false;
        if (video) { video.pause(); video.currentTime = 0; }
        /* Stop any playing card videos / iframes */
        section.querySelectorAll('.slime-lab__iframe-wrap').forEach(function (w) {
          w.remove();
        });
        section.querySelectorAll('.slime-lab__video-thumb').forEach(function (t) {
          t.classList.remove('is-playing');
        });
      });
    }
  }

  /* ── Auto-play all cards in the revealed panel ── */
  function autoPlayAll(section) {
    section.querySelectorAll('.slime-lab__video-card').forEach(function (card) {
      if (card.dataset.videoType) playCard(card);
    });
  }

  /* ── Play a single card (YouTube iframe or native video) ── */
  function playCard(card) {
    var type  = card.dataset.videoType;
    var thumb = card.querySelector('.slime-lab__video-thumb');
    if (!type || !thumb || thumb.classList.contains('is-playing')) return;

    var wrap = document.createElement('div');
    wrap.className = 'slime-lab__iframe-wrap';

    if (type === 'youtube') {
      var ytId = card.dataset.ytId;
      if (!ytId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(ytId) +
                   '?autoplay=1&mute=1&loop=1&controls=0&rel=0&enablejsapi=1&playlist=' +
                   encodeURIComponent(ytId);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      wrap.appendChild(iframe);
    } else if (type === 'direct') {
      var videoUrl = card.dataset.videoUrl;
      if (!videoUrl) return;
      var vid = document.createElement('video');
      vid.src        = videoUrl;
      vid.autoplay   = true;
      vid.muted      = true;
      vid.loop       = true;
      vid.controls   = false;
      vid.setAttribute('playsinline', '');
      vid.setAttribute('preload', 'metadata');
      vid.style.cssText = 'width:100%;height:100%;display:block;border:0;object-fit:cover;pointer-events:none;';
      wrap.appendChild(vid);
      var p = vid.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    } else { return; }

    thumb.classList.add('is-playing');
    thumb.appendChild(wrap);
  }

  /* ── Mute button toggle ── */
  function initMuteButtons(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.slime-lab__mute-btn');
      if (!btn) return;
      e.stopPropagation();

      var card    = btn.closest('.slime-lab__video-card');
      if (!card) return;

      var wasMuted = btn.classList.contains('is-muted');
      btn.classList.toggle('is-muted',   !wasMuted);
      btn.classList.toggle('is-unmuted',  wasMuted);

      var iframe = card.querySelector('.slime-lab__iframe-wrap iframe');
      var vid    = card.querySelector('.slime-lab__iframe-wrap video');

      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func:  wasMuted ? 'unMute' : 'mute',
          args:  []
        }), '*');
      }
      if (vid) { vid.muted = !wasMuted; }
    });
  }

  /* ── Carousel ── */
  function initCarousel(section) {
    var track   = section.querySelector('[data-slime-track]');
    var prevBtn = section.querySelector('[data-slime-prev]');
    var nextBtn = section.querySelector('[data-slime-next]');
    if (!track || !prevBtn || !nextBtn) return;

    var idx = 0;

    function cards() { return track.querySelectorAll('.slime-lab__video-card'); }

    function visibleCount() {
      var vp = track.parentElement;
      if (!vp) return VISIBLE;
      var w = vp.getBoundingClientRect().width;
      if (w < 550) return 1;   /* mobile: 1 card + peek on each side */
      return VISIBLE;
    }

    function slide() {
      var all = cards();
      var vis = visibleCount();
      var max = Math.max(0, all.length - vis);
      if (idx > max) idx = max;
      if (!all.length) return;
      var gap    = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var trackW = track.getBoundingClientRect().width;
      var vp     = track.parentElement;
      var vpW    = vp ? vp.getBoundingClientRect().width : trackW;
      var offset;
      if (vpW < 550) {
        /* Mobile peek carousel: use offsetWidth (layout width) — NOT
           getBoundingClientRect which is skewed by scale() transforms,
           causing off-center cards when idx > 0. */
        var cardW = all[0].offsetWidth;
        offset = (vpW - cardW) / 2 - idx * (cardW + gap);
      } else {
        /* Desktop: justify-content:center — compensate for that offset. */
        var cardW  = all[0].getBoundingClientRect().width;
        var totalW = all.length * cardW + (all.length - 1) * gap;
        var startOffset = totalW > trackW ? (totalW - trackW) / 2 : 0;
        offset = startOffset - idx * (cardW + gap);
      }
      track.style.transform = 'translateX(' + offset + 'px)';
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= max;

      // Mark the active card so CSS can scale it up on mobile
      all.forEach(function (card, i) {
        card.classList.toggle('is-active', i === idx);
      });
    }

    prevBtn.addEventListener('click', function () { if (idx > 0) { idx--; slide(); } });
    nextBtn.addEventListener('click', function () {
      var max = Math.max(0, cards().length - visibleCount());
      if (idx < max) { idx++; slide(); }
    });

    track.addEventListener('click', function (e) {
      var card = e.target.closest('.slime-lab__video-card');
      if (card) playCard(card);
    });

    /* Re-run slide() when the reveal panel first becomes visible,
       because getBoundingClientRect() returns 0 while display:none */
    section.addEventListener('slime:revealed', function () {
      requestAnimationFrame(function () { idx = 0; slide(); });
    });

    slide();
    window.addEventListener('resize', slide);
  }

})();
